import { useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "../context/AuthContext";
import { useAuthModal } from "../context/AuthModalContext";

// The signed-in user's saved shops, fetched once and shared by every heart
// on the page.
let cache = { userId: null, ids: null };

function savedIds(userId) {
  if (cache.userId !== userId) {
    cache = {
      userId,
      ids: api
        .get("/favorites")
        .then(({ data }) => new Set(data.map((b) => b.id)))
        .catch(() => new Set()),
    };
  }
  return cache.ids;
}

/** Whether the shop is in the user's favorites, and a way to flip it. */
export function useFavorite(business) {
  const { user } = useAuth();
  const { openAuthModal } = useAuthModal();
  const [saved, setSaved] = useState(false);
  const id = business?.id;
  const userId = user?.id;

  useEffect(() => {
    if (!userId || !id) {
      setSaved(false);
      return undefined;
    }
    let stale = false;
    savedIds(userId).then((ids) => {
      if (!stale) setSaved(ids.has(id));
    });
    return () => {
      stale = true;
    };
  }, [userId, id]);

  const toggle = async () => {
    if (!user) {
      openAuthModal("login");
      return;
    }
    const next = !saved;
    setSaved(next);
    const ids = await savedIds(user.id);
    try {
      if (next) {
        await api.post(`/favorites/${business.slug}`);
        ids.add(id);
      } else {
        await api.delete(`/favorites/${business.slug}`);
        ids.delete(id);
      }
    } catch {
      setSaved(!next);
    }
  };

  return [saved, toggle];
}
